import ChangePassword from "./changePassword";

export default ChangePassword;